export default {
    namespaced: true,
    state: {
        enable_client_apply: false,
        enable_client_approve: false,
        enable_client_login: false,
        enable_user_admin: false
    },
    mutations: {
        // 権限情報をセット
        setAuthorities(state, user_authorities) {
            state.enable_client_apply = user_authorities.hasOwnProperty('enable_client_apply')
                ? user_authorities.enable_client_apply
                : false;
            state.enable_client_approve = user_authorities.hasOwnProperty('enable_client_approve')
                ? user_authorities.enable_client_approve
                : false;
            state.enable_client_login = user_authorities.hasOwnProperty('enable_client_login')
                ? user_authorities.enable_client_login
                : false;
            state.enable_user_admin = user_authorities.hasOwnProperty('enable_user_admin')
                ? user_authorities.enable_user_admin
                : false;
        }
    },
    actions: {},
    getters: {
        // クライアント情報変更申請権限有無の判定
        getEnableClientApply(state) {
            return state.enable_client_apply;
        },
        // クライアント情報変更承認権限有無の判定
        getEnableClientApprove(state) {
            return state.enable_client_approve;
        },
        // なりすましログイン権限有無の判定
        getEnableClientLogin(state) {
            return state.enable_client_login;
        },
        // ユーザー管理機能利用権限有無の取得
        getEnableUesrAdmin(state) {
            return state.enable_user_admin;
        }
    }
};
